import React, { useState } from "react";
import { Table } from "reactstrap";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// componentes
import DeleteButton from "../../../components/Buttons/DeleteButton";
import ModalEditHotel from "./ModalEditHotel";
//service
import { deleteHotel } from "../../../utils/services/hotel";

export default function TableHotel(props) {
  const { hotels, idEvent, participants, data } = props;
  // modal
  const [modalEditHotel, setModalEditHotel] = useState(false);
  // hotel selecionado
  const [hotelSelected, setHotelSelected] = useState({});
  // alerta
  const [alertDelete, setAlertDelete] = useState(false);
  const [alertDeleteConfirmed, setAlertDeleteConfirmed] = useState(false);

  function formatData(startDate) {
    var data = new Date(startDate + "T00:00:00-03:00");
    var dia = String(data.getDate()).padStart(2, "0");
    var mes = String(data.getMonth() + 1).padStart(2, "0");
    var ano = data.getFullYear();
    var dataAtual = dia + "/" + mes + "/" + ano;

    return dataAtual;
  }

  async function confirmDelete() {
    await deleteHotel({
      jwt: "",
      id: hotelSelected.id,
    })
      .then((res) => {
        // console.log("deleted", res);
        if (res.message === "DELETED_HOTEL") {
          setAlertDelete(false);
          setAlertDeleteConfirmed(true);
        }
      })
      .catch((error) => {
        // console.log("erro", error);
      });
  }

  return (
    <>
      {modalEditHotel && (
        <ModalEditHotel
          isOpen={modalEditHotel}
          toggle={() => setModalEditHotel(false)}
          idEvent={idEvent}
          data={data}
          editHotel={hotelSelected}
          participants={participants}
        />
      )}

      {alertDelete && (
        <SweetAlert
          title={`Deseja deletar hospedagem em ${hotelSelected.hotel}?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete();
          }}
          onCancel={() => setAlertDelete(false)}
        >
          Você não poderá reverter essa ação.
        </SweetAlert>
      )}

      {alertDeleteConfirmed ? (
        <SweetAlert
          success
          title="Sucesso"
          onConfirm={() => {
            data();
            setAlertDeleteConfirmed(false);
          }}
        >
          Hotel deletado com sucesso
        </SweetAlert>
      ) : null}

      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Participante</th>
              <th>Hotel</th>
              <th>Data/hora checkIn</th>
              <th>Data/hora checkOut</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {hotels &&
              hotels
                ?.filter((e) => e.login.nome?.toLocaleLowerCase())
                ?.map((e, i) => (
                  <tr key={i}>
                    <td>{e.login.nome}</td>
                    <td>{e.hotel}</td>
                    <td>
                      {formatData(e.checkindate)} {e.checkintime}
                    </td>
                    <td>
                      {formatData(e.checkoutdate)} {e.ckeckouttime}
                    </td>
                    <td>
                      <i
                        className="mdi mdi-pencil"
                        style={{
                          color: "green",
                          fontSize: 17,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setHotelSelected(e);
                          setModalEditHotel(true);
                        }}
                      />
                      <DeleteButton
                        onClick={() => {
                          setHotelSelected(e);
                          setAlertDelete(true);
                        }}
                        color="red"
                        fontSize={17}
                      />
                    </td>
                  </tr>
                ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
